import { useState } from "react"
import { UserIcon, PencilSquareIcon } from "@heroicons/react/24/outline"
import { Section } from "./ui"
import { Modal } from "../../components/modal/Modal"

type Props = {
  text?: string
  onSave: (data: { bio: string }) => Promise<void> | void
}

export const AboutBlock = ({ text, onSave }: Props) => {
  const [open, setOpen] = useState(false)
  const [bio, setBio] = useState(text || "")
  const [saving, setSaving] = useState(false)

  const openEdit = () => {
    setBio(text || "")
    setOpen(true)
  }

  const handleSave = async () => {
    try {
      setSaving(true)
      await onSave({ bio })
      setOpen(false)
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <Section
        id="about"
        title="About"
        icon={UserIcon}
        iconColor="text-gray-500 bg-gray-100"
        onAdd={openEdit}
        addLabel="Edit"
        addIcon={PencilSquareIcon}
      >
        <p className="text-sm text-gray-600 leading-relaxed">
          {text || (
            <span className="text-gray-400 italic">
              Add a short summary about yourself, your experience, stack and professional goals.
            </span>
          )}
        </p>
      </Section>

      <Modal open={open} onClose={() => setOpen(false)} title="Edit about">
        <div className="space-y-4">
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            placeholder="A short summary about yourself, your experience, stack and professional goals…"
            rows={5}
            className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />

          <div className="flex justify-end gap-2 pt-1">
            <button
              onClick={() => setOpen(false)}
              className="border border-gray-200 px-4 py-2 rounded-lg text-sm hover:bg-gray-50 transition"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm disabled:opacity-50 hover:bg-blue-700 transition"
            >
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
